import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import AfterHoursSpacesDropDown from 'components/FacilityRequestComponents/AH/Reusable/AfterHoursSpacesDropDown';
import AfterHoursMyRequests from 'components/FacilityRequestComponents/AH/AfterHoursMyRequests';
import styles from '../Maintenance/maintenance.module.css';
import AHstyles from './Modules/AfterHours.module.css';

export default class AfterHoursList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            navigateToCreateMaintenance_state: false,
            selectedZone: null,
        };
        this.navigateToCreateMaintenance = this.navigateToCreateMaintenance.bind(this);
        this.getSelectedZoneDetails = this.getSelectedZoneDetails.bind(this);
    }

    navigateToCreateMaintenance() { this.setState({ navigateToCreateMaintenance_state: true }) }

    render() {
        let default_selectedZoneDetailID = null;
        //Navigate or redirect to create after hours request
        if (this.state.navigateToCreateMaintenance_state) {
            return <Redirect to={{ pathname: '/FacilityManagement/CreateAfterHoursRequest', state: { zoneSelectedfromDropdown: this.state.selectedZone } }} />
        }
        //Get default zone 
        if(this.props.location.state !==undefined  ){
            default_selectedZoneDetailID = this.props.location.state.zoneSelectedfromDropdown;
        }
        return (
            <div>
                <div className={styles.titleSection}>
                    <SubTitle text={"After-Hours"} />
                    <button onClick={this.navigateToCreateMaintenance} className={styles.add_navigate_Button}>+ AFTER-HOURS REQUEST</button>
                </div>

                <div className={styles.whiteContainer}>
                    <div className={AHstyles.fieldrow}> <AfterHoursSpacesDropDown onSelectedZoneDetails={this.getSelectedZoneDetails} defaultZoneSlection={(localStorage.getItem("zoneSelectedfromList")==="true") ? this.state.selectedZone !== null ? this.state.selectedZone.zoneId : default_selectedZoneDetailID : default_selectedZoneDetailID}/> </div>
                    <div className={AHstyles.fieldrow}>
                        {/* <p className={AHstyles.documentsLightFontLabel}>Run Mode</p>
                        <p className={AHstyles.documentsBoldLabel} >{"Occupied until 05:00PM"}</p> */}
                        {/* <p className={AHstyles.viewNormalHoursLink} onClick={this.toggle}>View Daily Normal Operating Hours</p> */}
                    </div>

                    <div className={AHstyles.fieldrow}>

                        <Nav tabs>
                            <NavItem className={styles.nav_item_first}>
                                <NavLink className={classnames({ active: true }, [styles.active_tab])} > My Requests </NavLink>  </NavItem>
                        </Nav>

                        <TabContent activeTab={"1"} className={styles.tabcontent} style={{ maxHeight: "1000px !important" }} >
                            <TabPane tabId="1" className={styles.tabcontentcontainer} style={{ maxHeight: "1000px !important",marginTop:'0px' }}><AfterHoursMyRequests selectZoneDetails={this.state.selectedZone} />  </TabPane>
                        </TabContent>

                    </div>
                </div>
            </div>
        );
    }

    // On Zone/Space dropdown change.
    getSelectedZoneDetails(selectedZoneDetail) {
        if (selectedZoneDetail !== null || selectedZoneDetail !== undefined) {
            this.setState({ selectedZone: selectedZoneDetail });
        }
    }

}